import Button from '@ui/buttons/Button'
import { PackageConfig, PackageVariant, PriceValue } from '@ca/common/types'
import { ModalBottom } from '@ui/components/Modal'
import DetailRow from '@ui/elements/DetailRow'
import PriceInfo from '@/price/PriceInfo'
import getPackageLabels from '@order/getPackageLabels'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { getFirstExistingKey, joinPaths } from 'utils/i18nUtils'

export type UpgradePackageVariant = {
  current: PackageVariant | PackageConfig
  next: PackageVariant
  package: PackageConfig
}

export interface OptionUpgradeModalProps {
  open: boolean
  upgrade: UpgradePackageVariant | null
  onUpgrade: () => void
  onClose: () => void
}

export default function OptionPackageVariantModal({
  open,
  upgrade,
  onUpgrade,
  onClose,
}: OptionUpgradeModalProps) {
  const { t, i18n } = useTranslation(['ui', 'upgrades'])
  const config = useRemoteConfig()

  const basePrefix = `upgrades:packageVariant`

  if (!upgrade) {
    return null
  }
  const newPrice = PriceValue.safe(upgrade.next.price, config?.region)
  const basePrice = PriceValue.safe(upgrade.current?.price, config?.region)
  const priceDiff = Math.max(newPrice - basePrice, 0)

  const { title } = getPackageLabels({
    value: upgrade.next.value,
    i18n,
  })

  const descKey = getFirstExistingKey(i18n, [
    title,
    // Fallback to this key if the title is not translated
    `${basePrefix}.${upgrade.next.lensPrefix?.toLowerCase()}`,
  ])
  return (
    <ModalBottom
      open={open}
      close={onClose}
      title={t(`${basePrefix}.title`)}
      desc={t(`${basePrefix}.desc`)}
      body={
        <View className="flex  flex-col px-16">
          <View className="overflow-hidden rounded-2xl border border-black/10">
            <DetailRow
              icon="diamond"
              className="border-none"
              desc={descKey ? t(descKey) : undefined}
            >
              <PriceInfo value={priceDiff} size="default" />
            </DetailRow>
          </View>
        </View>
      }
      buttons={
        <View className="flex flex-row items-start gap-8">
          <Button
            variant="filled"
            onPress={onUpgrade}
            label={t('ui:upgradeNow')}
          />
          <Button variant="outlined" onPress={onClose} label={t('ui:cancel')} />
        </View>
      }
    />
  )
}
